import dayjs from 'dayjs';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';

if (!dayjs.utc) {
  dayjs.extend(utc);
}

if (!dayjs.tz) {
  dayjs.extend(timezone);
}

export function formatBoldText(text: string, className?: string): string {
  return text.replace(/\*\*\*(.*?)\*\*\*/g, className ? `<b class='${className}'>$1</b>` : '<b>$1</b>');
}

const formatKST = (timestamp: number) => dayjs(timestamp).tz('Asia/Seoul').format('YY.MM.DD');

export function formatDateRange(start: number, end: number): string {
  return `${formatKST(start)} ~ ${formatKST(end)}`;
}
